<template>
    <div
        v-if="status.value != 0"
        class="progress-width"
        :style="{
            background: `${status.color}`,
            width: `${status.value}%`
        }"
    ></div>
</template>

<script>
export default {
    name: 'progress-bar',
    props: {
        status: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
.progress-width {
    border-radius: 1px;
    height: 100%;
}
</style>
